'use strict';

import React from 'react';
import MediaList from './MediaListComponent';
import Navigator from './NavigatorComponent';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import Loading from './LoadingComponent';

require('styles/UserIncome.scss');

class UserIncomeComponent extends React.Component {
  constructor(props) {
    super(props);
    let userStore = UserStore.getState();
    this.state = {
      paidMedias: userStore.paidMedias,
      loading: userStore.paidMediasLoading,
      hasMore: userStore.paidMediasHasMore,
      showNavigator: false
    }
    this.onChange = this.onChange.bind(this);
    this.onMediaScroll = this.onMediaScroll.bind(this);
    this.loadMore = this.loadMore.bind(this)
  }
  componentDidMount() {
    UserStore.listen(this.onChange);
    UserActions.clearData('paidMedias');
    UserActions.fetchPaidMedias(this.props.id);
    window.addEventListener('scroll', this.onMediaScroll);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onChange);
    window.removeEventListener('scroll', this.onMediaScroll);
  }
  onChange(state) {
    this.setState({
      paidMedias: state.paidMedias,
      loading: state.paidMediasLoading,
      hasMore: state.paidMediasHasMore
    });
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.id !== nextProps.id) {
      UserActions.clearData('paidMedias');
      UserActions.fetchPaidMedias(nextProps.id);
    }
  }
  onMediaScroll(event) {
    if(this.state.fetchTimeout) {
      clearTimeout(this.state.fetchTimeout);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      UserActions.setLoading({paidMediasLoading: true});
      this.setState({fetchTimeout: setTimeout(UserActions.fetchPaidMedias.bind(null, this.props.id), 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else {
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    UserActions.setLoading({paidMediasLoading: true}); 
    UserActions.fetchPaidMedias(this.props.id)
  }
  render() {
    let noMoreWord,navigator;
    if(this.state.paidMedias.length === 0) {
      noMoreWord = ' ';
    }
    if(this.state.showNavigator){
      navigator = <Navigator action = 'top' number={2} />;
    }
    return (
      <div className={this.props.active ? 'userincome-component tabs-panel is-active pb-30' : 'userincome-component tabs-panel pb-30'}>
        <MediaList medias={this.state.paidMedias} loading={this.state.loading} />
        <Loading noMoreWord={noMoreWord} loading={this.state.loading} hasMore={this.state.hasMore} loadMore={this.loadMore}/>
        {navigator}
        <Navigator action = 'left' />
      </div>
    );
  }
}

UserIncomeComponent.displayName = 'UserIncomeComponent';
export default UserIncomeComponent;



// WEBPACK FOOTER //
// ./src/components/UserIncomeComponent.js